cb.define(['common/common_VM.Extend.js'], function(common) {
	var ST_st_storetransferlist_filterVM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			viewmodel.on("afterInit", function() {
				debugger
				//业务类型过滤条件
				var conditionBustype = {
					"isExtend": true,
					simpleVOs: []
				};
				conditionBustype.simpleVOs.push({
					field: 'receipttype.code',
					op: 'eq',
					value1: 'A11'
				});
				viewmodel.get('businesstype').getFromModel().setFilter(conditionBustype);
				//出入库仓库过滤条件
				var conditionBustype = {
					"isExtend": true,
					simpleVOs: []
				};
				var storeid = cb.rest.AppContext.user.storeId;
				conditionBustype.simpleVOs.push({
					field: 'store',
					op: 'eq',
					value1: storeid
				});
				viewmodel.get('outWarehouse').getFromModel().setFilter(conditionBustype);
				viewmodel.get('inWarehouse').getFromModel().setFilter(conditionBustype);
				//      viewmodel.get('voucherdate').getFromModel().setValue('1')
				//      viewmodel.get('voucherdate').getToModel().setValue('31')
			});
			viewmodel.on("beforeSearch", function(data) {
//				debugger
			});
		}

	}
	try {
		module.exports = ST_st_storetransferlist_filterVM_Extend;
	} catch(error) {

	}
	return ST_st_storetransferlist_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storetransferlist_filterVM.Extend.js